import customersGroups from './customersGroups';
import customers from './customers';
import salers from './salers';
import salersGroup from './salersGroup';
export default { customersGroups, customers, salers, salersGroup, }